import { KText } from '@/ui-library/components/text';
import { Flex, Box } from '@chakra-ui/react';

const Metrics = ({ value = '', label = '' }) => {
  return (
    <Box flex="1" textAlign="center">
      <KText color="secondary-900" size="sm-semi-bold">
        {value}
      </KText>
      <KText color="secondary-700">{label}</KText>
    </Box>
  );
};

export const BlueprintMetrics = ({ blueprint = {} }) => {
  return (
    <Flex
      height="96px"
      borderBottom="1px solid #E5E5E5"
      px="20px"
      alignItems="center"
    >
      <Metrics value={blueprint?.used} label="Times used" />
      <Metrics value={blueprint?.stats?.sent_count} label="Sent" />
      <Metrics value={blueprint?.days} label="Days in Sequence" />
      <Metrics value={blueprint?.stats?.reply_count} label="Replied" />
      <Metrics value={blueprint?.stats?.interested_count} label="Interested" />
    </Flex>
  );
};
